import {
    WAITLISTS_CLOSE_PANEL_ACTION_TYPE,
    WAITLISTS_COUNTS_FETCH_SUCCESS_ACTION_TYPE,
    WAITLISTS_DELETE_START_ACTION_TYPE,
    WAITLISTS_DELETE_SUCCESS_ACTION_TYPE,
    WAITLISTS_ERROR_ACTION_TYPE,
    WAITLISTS_FETCH_START_ACTION_TYPE,
    WAITLISTS_FETCH_SUCCESS_ACTION_TYPE,
    WAITLISTS_GET_START_ACTION_TYPE,
    WAITLISTS_GET_SUCCESS_ACTION_TYPE,
    WAITLISTS_OPEN_PANEL_ACTION_TYPE,
    WAITLISTS_RESET_ACTION_TYPE,
    WAITLISTS_HIDE_FORM_ACTION_TYPE,
    WAITLISTS_SAVE_SUCCESS_ACTION_TYPE,
    WAITLISTS_SELECT_ACTION_TYPE,
    WAITLISTS_SHOW_FORM_ACTION_TYPE,
    WAITLISTS_START_CONVERSION_ACTION_TYPE,
    WAITLISTS_END_CONVERSION_ACTION_TYPE,
    WAITLISTS_REFRESH_LIST_ACTION_TYPE,
    WaitlistsAction
} from 'actions/waitlists/WaitlistsActionsTypes';
import { WaitlistsState, WaitlistsStatus } from 'reducers/waitlists/WaitlistsState';
import { Reducer } from 'redux';

const initialState: WaitlistsState = {
    loading: false,
    status: WaitlistsStatus.Initial,
    waitlists: [],
    listVersion: 0,
    panel: {
        open: false,
        key: 'all',
        marketplaceIds: []
    }
};

export const waitlistsReducer: Reducer<WaitlistsState, WaitlistsAction> = (state = initialState, action) => {
    switch (action.type) {
        case WAITLISTS_RESET_ACTION_TYPE:
            return {
                ...initialState
            };

        case WAITLISTS_ERROR_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: WaitlistsStatus.Error
            };

        case WAITLISTS_OPEN_PANEL_ACTION_TYPE:
            return {
                ...state,
                selected: undefined,
                panel: {
                    open: true,
                    key: action.payload.key,
                    marketplaceIds: action.payload.marketplaceIds,
                    selectedWaitlistId: action.payload.waitlistId
                }
            };

        case WAITLISTS_CLOSE_PANEL_ACTION_TYPE:
            return {
                ...state,
                selected: undefined,
                panel: {
                    ...state.panel,
                    open: false,
                    selectedWaitlistId: undefined,
                    form: undefined
                }
            };

        case WAITLISTS_SELECT_ACTION_TYPE:
            return {
                ...state,
                selected: undefined,
                panel: {
                    ...state.panel,
                    selectedWaitlistId: action.payload.waitlistId
                }
            };

        case WAITLISTS_SHOW_FORM_ACTION_TYPE:
            return {
                ...state,
                panel: {
                    ...state.panel,
                    open: true,
                    form: { waitlistId: action.payload.waitlistId }
                }
            };

        case WAITLISTS_HIDE_FORM_ACTION_TYPE:
            return {
                ...state,
                panel: {
                    ...state.panel,
                    form: undefined
                }
            };

        case WAITLISTS_SAVE_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                selected: action.payload.waitlist,
                listVersion: state.listVersion + 1,
                panel: {
                    ...state.panel,
                    form: undefined,
                    selectedWaitlistId: action.payload.waitlist.id
                }
            };

        case WAITLISTS_START_CONVERSION_ACTION_TYPE:
            // The waitlist panel closes while Add Appointment is open.
            return {
                ...state,
                conversion: action.payload,
                panel: {
                    ...state.panel,
                    open: false,
                    form: undefined
                }
            };

        case WAITLISTS_END_CONVERSION_ACTION_TYPE:
            // Booked: the list and counts are fetched again (the backend decides whether it was converted).
            // Closed without booking: go back to its detail, unchanged.
            return {
                ...state,
                conversion: undefined,
                selected: action.payload.booked ? undefined : state.selected,
                listVersion: action.payload.booked ? state.listVersion + 1 : state.listVersion,
                panel: action.payload.booked
                    ? { ...state.panel, open: false, selectedWaitlistId: undefined }
                    : { ...state.panel, open: true, selectedWaitlistId: state.conversion?.waitlist.id }
            };

        case WAITLISTS_REFRESH_LIST_ACTION_TYPE:
            return {
                ...state,
                listVersion: state.listVersion + 1
            };

        case WAITLISTS_FETCH_START_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: WaitlistsStatus.FetchStart
            };

        case WAITLISTS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: WaitlistsStatus.FetchSuccess,
                waitlists: action.payload.append
                    ? [
                          ...state.waitlists,
                          ...action.payload.waitlists.filter(
                              waitlist => !state.waitlists.some(current => current.id === waitlist.id)
                          )
                      ]
                    : action.payload.waitlists,
                pagination: action.payload.pagination
            };

        case WAITLISTS_COUNTS_FETCH_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                counts: action.payload.counts
            };

        case WAITLISTS_GET_START_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: WaitlistsStatus.GetStart
            };

        case WAITLISTS_GET_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: WaitlistsStatus.GetSuccess,
                selected: action.payload.waitlist,
                waitlists: state.waitlists.map(waitlist =>
                    waitlist.id === action.payload.waitlist.id ? action.payload.waitlist : waitlist
                )
            };

        case WAITLISTS_DELETE_START_ACTION_TYPE:
            return {
                ...state,
                loading: true,
                status: WaitlistsStatus.DeleteStart
            };

        case WAITLISTS_DELETE_SUCCESS_ACTION_TYPE:
            return {
                ...state,
                loading: false,
                status: WaitlistsStatus.DeleteSuccess,
                selected: undefined,
                waitlists: state.waitlists.filter(waitlist => waitlist.id !== action.payload.waitlistId),
                pagination: state.pagination && {
                    ...state.pagination,
                    totalRecords: Math.max(0, state.pagination.totalRecords - 1)
                },
                panel: {
                    ...state.panel,
                    selectedWaitlistId: undefined
                }
            };

        default:
            return state;
    }
};

export default waitlistsReducer;
